import { useAuthStore } from "@persisted-state/auth/auth.store";

const SHIPPING_AGENT_ROLE = "shipping-agent";
const OPERATIONS_ROLE = "operations";

export const isCargoOpsShippingAgentRoles = (roles: readonly string[]): boolean =>
  roles.includes(SHIPPING_AGENT_ROLE) && !roles.includes(OPERATIONS_ROLE);

export const useIsCargoOpsShippingAgent = (): boolean =>
  useAuthStore((state) => isCargoOpsShippingAgentRoles(state.user?.roles ?? []));
